module.exports = "/_next/static/images/55a8e651b25f9f731e031bf67c86b2e7-savings-waitlist-promise-3b-lg-1x.jpg.webp";